import * as _dayjs2 from "dayjs";
var _dayjs = "default" in _dayjs2 ? _dayjs2.default : _dayjs2;
import { dew as _AbstractParserWithWordBoundaryDew } from "../../../../common/parsers/AbstractParserWithWordBoundary";
import { dew as _constantsDew } from "../constants";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var __importDefault = exports && exports.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  const dayjs_1 = __importDefault(_dayjs);
  const AbstractParserWithWordBoundary_1 = _AbstractParserWithWordBoundaryDew();
  const constants_1 = _constantsDew();
  const PATTERN = new RegExp("(?:\u661F\u671F|\u793C\u62DC|\u5468)(?<weekday>" + Object.keys(constants_1.WEEKDAY_OFFSET).join("|") + ")");
  class ZHHansWeekdayParser extends AbstractParserWithWordBoundary_1.AbstractParserWithWordBoundaryChecking {
    innerPattern() {
      return PATTERN;
    }
    innerExtract(context, match) {
      const result = context.createParsingResult(match.index, match[0]);
      const dayOfWeek = match.groups.weekday;
      const offset = constants_1.WEEKDAY_OFFSET[dayOfWeek];
      if (offset === undefined) return null;
      let startMoment = dayjs_1.default(context.refDate);
      const startMomentFixed = false;
      const refOffset = startMoment.day();
      if (Math.abs(offset - 7 - refOffset) < Math.abs(offset - refOffset)) {
        startMoment = startMoment.day(offset - 7);
      } else if (Math.abs(offset + 7 - refOffset) < Math.abs(offset - refOffset)) {
        startMoment = startMoment.day(offset + 7);
      } else {
        startMoment = startMoment.day(offset);
      }
      result.start.assign("weekday", offset);
      if (startMomentFixed) {
        result.start.assign("day", startMoment.date());
        result.start.assign("month", startMoment.month() + 1);
        result.start.assign("year", startMoment.year());
      } else {
        result.start.imply("day", startMoment.date());
        result.start.imply("month", startMoment.month() + 1);
        result.start.imply("year", startMoment.year());
      }
      return result;
    }
  }
  exports.default = ZHHansWeekdayParser;
  //# sourceMappingURL=ZHHansWeekdayParser.js.map
  return exports;
}